/* Catalog-bound NEW cart intent. Quote and signed references belong to checkout. */
if (!customElements.get('bm-new-buybox')) {
  customElements.define('bm-new-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-bm-new-cart-action]');
      this.note = this.querySelector('[data-bm-new-quote-note]');
      this.unavailable = this.querySelector('[data-bm-new-cart-unavailable]');
      this.quantitySelect = this.querySelector('[data-bm-new-quantity-select]');
      this.quantitySelect?.addEventListener('change', () => {
        const quantity = Number(this.quantitySelect.value);
        if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 20) return;
        const product = this.closest?.('bm-new-product');
        if (product?.setSelectedQuantity) product.setSelectedQuantity(quantity);
        else if (this.context) this.setContext({ ...this.context, quantity });
      });
      this.button?.addEventListener('click', () => this.purchase());
      this.querySelector('[data-bm-new-next-action]')?.addEventListener('click', () => {
        const product = this.closest?.('bm-new-product');
        if (this.guidanceState === 'configuration_required') {
          const choices = product?.querySelector('[data-bm-new-size-options]:not([hidden]), [data-bm-new-configuration-choice]:not([hidden])');
          choices?.scrollIntoView?.({ block: 'center', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'instant' : 'smooth' });
          choices?.querySelector('button,select')?.focus?.({ preventScroll: true });
        } else if (this.guidanceState === 'error') {
          product?.querySelector('[data-bm-new-fitment-retry]')?.click();
        } else {
          product?.querySelector('[data-bm-new-vehicle-state] [data-bm-compat-action]')?.click();
        }
      });
      this.querySelector('[data-bm-new-fitment-advice]')?.addEventListener('click', () => {
        this.dataset.bmAdvicePurpose = 'fitment';
        this.saveCompleteSetAdvice();
        const title = this.querySelector('.bm-new-buybox__tyre-title');
        const intro = this.querySelector('.bm-new-buybox__tyre-intro');
        if (title) title.textContent = 'Passing laten controleren';
        if (intro) intro.textContent = 'We controleren deze velg voor jouw auto. Je gekozen auto en velg staan hieronder al ingevuld.';
        const summary = this.querySelector('[data-bm-new-advice-action]');
        if (summary) summary.textContent = 'Jouw aanvraag';
        const details = this.querySelector('[data-bm-new-advice-inline]');
        if (details) details.open = true;
        const form = this.querySelector('.bm-new-buybox__advice-form');
        form?.querySelectorAll('[data-bm-new-tyre-field]').forEach(field => { field.hidden = true; });
        const notes = form?.querySelector('[name="contact[body]"]');
        if (notes) notes.placeholder = 'Vragen of bijzonderheden over je auto of deze velg';
        if (notes && (!notes.value.trim() || notes.value === 'Graag ontvang ik persoonlijk advies voor een complete set velgen met banden.')) {
          notes.value = 'Kunnen jullie controleren of deze velg op mijn auto past?';
        }
        form?.scrollIntoView?.({ block: 'center', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'instant' : 'smooth' });
        form?.querySelector('[name="contact[name]"]')?.focus?.({ preventScroll: true });
      });
      this.querySelector('[data-bm-new-change-auto]')?.addEventListener('click', () => {
        const product = this.closest?.('bm-new-product');
        const href = product?.selectorHref?.();
        if (href) location.assign(href);
      });
      const advice = this.querySelector('[data-bm-new-advice-action]');
      advice?.addEventListener('click', () => {
        if (this.dataset.bmAdvicePurpose !== 'fitment') this.querySelectorAll?.('[data-bm-new-tyre-field]').forEach(field => { field.hidden = false; });
        this.saveCompleteSetAdvice();
      });
      const adviceForm = this.querySelector('.bm-new-buybox__advice-form');
      // Native Shopify contact submission. Do not intercept or simulate delivery.
      adviceForm?.addEventListener('submit', () => this.saveCompleteSetAdvice());
      const feedback = this.querySelector('[data-bm-new-advice-feedback]');
      if (feedback) {
        const details = this.querySelector('[data-bm-new-advice-inline]');
        if (details) details.open = true;
        const tyreAdvice = this.querySelector('[data-bm-new-tyre-advice]');
        if (tyreAdvice) tyreAdvice.open = true;
      }
    }

    saveCompleteSetAdvice() {
      // S1: reuse Shopify's native contact-form owner in place on the PDP.
      // Do not navigate to contact, quote, check out or place supplier orders.

      const product = this.closest?.('bm-new-product');
      const selected = window.BandenmeestersVehicle?.getNewVehicle?.() || null;
      const value = (text, max = 200) => String(text ?? '').trim().slice(0, max);
      const label = (selector, max) => {
        const node = product?.querySelector?.(selector);
        // Decorative info buttons are part of the product UI, not the written wheel specification.
        if (selector === '[data-bm-new-techline]' && node?.cloneNode) {
          const cleaned = node.cloneNode(true);
          cleaned.querySelectorAll?.('button,[aria-hidden="true"],svg').forEach(element => element.remove());
          return value(cleaned.textContent, max);
        }
        return value(node?.textContent, max);
      };
      const vehicleId = value(this.context?.vehicleId || selected?.vehicleId || selected?.id, 60);
      const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
      let vehicleLabel = '';
      try { vehicleLabel = value(window.BandenmeestersVehicle?.vehicleLabel?.(window.BandenmeestersVehicle?.getActive?.()) || selected?.label); } catch (_) {}
      const context = {
        v: 1, at: Date.now(),
        productRef: value(this.context?.productRef || product?.dataset?.shopifyProductRef, 30),
        productUrl: value(new URL(product?.dataset?.productUrl || window.location.pathname, window.location.origin).href, 500),
        productTitle: label('[data-bm-new-design]'),
        finish: label('[data-bm-new-finish-label]'),
        specification: label('[data-bm-new-techline]', 240).replace(/\s+/g, ' '),
        setId: value(this.context?.setId, 60),
        variantId: value(this.context?.variantId, 30),
        quantity: Number.isInteger(this.context?.quantity) && this.context.quantity >= 1 && this.context.quantity <= 20
          ? this.context.quantity : 4,
        vehicleUuid: uuid.test(vehicleId) ? vehicleId : '',
        vehicleLabel,
      };
      const form = this.querySelector('.bm-new-buybox__advice-form');
      if (!form) return;
      const assign = (selector, input) => {
        const field = form.querySelector(selector);
        if (field) field.value = value(input, 700);
      };
      const details = [context.productTitle,context.finish,context.specification,
        context.quantity + (context.quantity === 1 ? ' velg' : ' velgen')].filter(Boolean).join(' · ');
      assign('[data-bm-new-advice-product-ref]', context.productRef);
      assign('[data-bm-new-advice-product-link]', context.productUrl);
      assign('[data-bm-new-advice-wheel-spec]', details);
      assign('[data-bm-new-advice-quantity]', context.quantity);
      assign('[data-bm-new-advice-set-id]', context.setId);
      assign('[data-bm-new-advice-variant]', context.variantId);
      assign('[data-bm-new-advice-vehicle-id]', context.vehicleUuid);
      const summary = this.querySelector('[data-bm-new-advice-summary]');
      if (summary) summary.textContent = details || context.productTitle || 'deze velgen';
      const vehicle = form.querySelector('[data-bm-new-advice-vehicle]');
      // A manually entered vehicle must not be overwritten on later clicks/submission.
      if (vehicle && !vehicle.value.trim() && context.vehicleLabel) vehicle.value = context.vehicleLabel;
      // No session or URL state is required for this on-product inquiry.
    }

    updatePrimaryAction() {
      if (!this.button) return;
      const inquiry = this.dataset?.bmInquiryMode === 'true';
      this.button.hidden = inquiry;
      this.button.disabled = !this.context || Boolean(this.busy) || !this.nativeCartEligible(this.context)
        || this.dataset?.bmFitmentBlocked === 'true';
      this.syncPurchaseGuidance();
    }

    syncPurchaseGuidance(state) {
      if (state) this.guidanceState = state;
      const next = this.querySelector('[data-bm-new-next-action]');
      const status = this.querySelector('[data-bm-new-purchase-guidance]');
      if (!next || !status || !this.button) return;
      const mode = this.guidanceState || 'not_checked';
      const ready = Boolean(this.context && this.nativeCartEligible(this.context)
        && this.dataset?.bmFitmentBlocked !== 'true');
      const inquiry = this.dataset?.bmInquiryMode === 'true';
      const checking = mode === 'checking';
      const choices = {
        configuration_required: ['Kies je velgmaat', 'Kies je velgmaat om de prijs te bekijken.'],
        not_checked: ['Kies je auto', 'Kies je auto om deze velgmaat te controleren.'],
        checking: ['Passing controleren…', 'Je autokeuze is opgeslagen. We controleren nu deze velgmaat.'],
        blocked: ['Bekijk passende velgen voor mijn auto', 'Deze uitvoering past niet op jouw auto. Bekijk passende alternatieven of laat ons meedenken.'],
        review_required: ['Bekijk passende velgen voor mijn auto', 'Voor deze velg hebben we geen bevestigde passende uitvoering voor jouw auto. Bekijk passende velgen of laat ons de passing controleren.'],
        other_configuration: ['Bekijk passende maten', 'Een andere maat van dit design past. Kies hierboven een passende velgmaat.'],
        error: ['Probeer de controle opnieuw', 'De passingcontrole is niet gelukt. Probeer opnieuw of vraag ons advies.'],
      };
      const needsHelp = !ready && ['review_required', 'blocked'].includes(mode);
      this.dataset.bmFitmentHelp = String(needsHelp);
      const help = this.querySelector('[data-bm-new-fitment-help]');
      if (help) help.hidden = !needsHelp;
      const quantityLabel = this.querySelector('.bm-new-buybox__quantity-label');
      if (quantityLabel) quantityLabel.hidden = !ready;
      const copy = ready ? ['', '']
        : inquiry && !needsHelp ? ['', 'Deze uitvoering is niet online bestelbaar. Vraag ons naar de mogelijkheden.']
        : choices[mode] || choices.not_checked;
      this.button.hidden = inquiry || !ready;
      next.hidden = ready || (inquiry && !needsHelp);
      next.disabled = checking || Boolean(this.busy);
      next.textContent = copy[0];
      status.textContent = copy[1];
      status.hidden = ready;
      this.dataset.bmPurchaseFeedback = ready ? 'ready' : checking ? 'checking' : 'attention';
    }
    validContext(context) {
      const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return context?.setType === 'SQUARE' && Number.isSafeInteger(context.quantity) && context.quantity >= 1 && context.quantity <= 20
        && (context.vehicleId === undefined || uuid.test(context.vehicleId))
        && /^[1-9][0-9]*$/.test(context.variantId || '')
        && /^[1-9][0-9]*$/.test(context.productRef || '')
        && uuid.test(context.setId || '');
    }

    setContext(context) {
      const next = this.validContext(context) ? context : null;
      const changed = JSON.stringify(next) !== JSON.stringify(this.context);
      if (changed) this.message('');
      this.context = next;
      if (this.quantitySelect) this.quantitySelect.value = String(next?.quantity ?? 4);
      const blocked = Boolean(next && !this.nativeCartEligible(next));
      // Reuse the existing product-specific enquiry action when Shopify cannot
      // accept the chosen physical quantity or the canonical price is explicitly null.
      // This changes presentation only; it never weakens native cart guards.
      const inquiry = blocked || this.dataset?.bmNoPrice === 'true';
      if (this.dataset) this.dataset.bmInquiryMode = String(inquiry);
      if (this.unavailable) this.unavailable.hidden = !blocked;
      if (this.button) {
        this.button.hidden = inquiry;
        this.button.disabled = !next || Boolean(this.busy) || Boolean(blocked)
          || this.dataset?.bmFitmentBlocked === 'true';
        this.button.textContent = this.busy ? 'Toevoegen…' : blocked ? 'Niet online bestelbaar' : 'In winkelwagen';
      }
      this.syncPurchaseGuidance();
    }

    nativeCartEligible(context) {
      const stock = this.dataset?.bmNativeCartStock;
      // A fresh checkout Quote, not this Shopify observation, authorizes purchase.
      if (stock !== undefined) {
        try {
          const levels = JSON.parse(stock);
          const available = levels?.[String(context?.variantId)];
          return levels && !Array.isArray(levels) && Number.isSafeInteger(available)
            && available > 0 && available >= context.quantity;
        } catch (_) { return false; }
      }
      const source = this.dataset?.bmNativeCartVariants;
      // Older section markup can still use Shopify's authoritative cart response.
      if (source === undefined) return context?.quantity === 4;
      try {
        const ids = JSON.parse(source);
        return Array.isArray(ids) && ids.every(id => /^[1-9][0-9]*$/.test(String(id)))
          && context.quantity <= 4 && ids.some(id => String(id) === String(context?.variantId));
      } catch (_) { return false; }
    }

    message(text) {
      if (!this.note) return;
      this.note.textContent = text; this.note.hidden = !text; this.note.setAttribute('role', 'status');
    }

    async purchase() {
      if (this.dataset?.bmFitmentBlocked === 'true') return;
      if (!this.validContext(this.context) || !this.nativeCartEligible(this.context) || this.busy) return;
      const context = { ...this.context };
      this.busy = true; this.button.disabled = true; this.button.textContent = 'Toevoegen…';
      this.message('');
      let committed = false;
      let accepted = false;
      let posted = false;
      let shopifyError = '';
      try {
        const ctx = { v: 1, productRef: context.productRef, setId: context.setId,
          ...(context.vehicleId ? { vehicleId: context.vehicleId } : {}) };
        const snapshot = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin', cache: 'no-store' });
        const cart = await snapshot.json();
        if (!snapshot.ok || !Array.isArray(cart.items)) throw new Error('cart_snapshot_failed');
        if (JSON.stringify(this.context) !== JSON.stringify(context)) {
          this.message('Je keuze is gewijzigd. Voeg de gekozen uitvoering opnieuw toe.');
          return;
        }
        if (this.dataset?.bmFitmentBlocked === 'true') {
          this.message('Deze velg past niet op de gekozen auto. Wijzig je keuze voordat je toevoegt.');
          return;
        }
        const matchesIntent = line => {
          let intent;
          try { intent = JSON.parse(line.properties?._bm_ctx); } catch (_) { return false; }
          return String(line.product_id) === context.productRef && String(line.variant_id) === context.variantId
            && intent?.v === 1 && String(intent.productRef) === context.productRef && intent.setId === context.setId;
        };
        const existing = cart.items.find(matchesIntent);
        // Vehicle is optional intent metadata; current garage and fresh fitment belong to checkout.
        if (existing?.quantity === context.quantity) {
          committed = true;
          this.message('Deze set staat al in je winkelwagen.');
          location.assign(window.routes?.cart_url || '/cart');
          return;
        }
        const minicart = window.miniCart;
        const body = { ...(existing ? { id: existing.key, quantity: context.quantity,
          ...(existing.properties?._bm_ref ? { properties: { ...existing.properties, _bm_ctx: JSON.stringify(ctx), _bm_ref: undefined } } : {})
        } : { items: [{ id: context.variantId, quantity: context.quantity, properties: { _bm_ctx: JSON.stringify(ctx) } }] }),
          ...(minicart ? { sections: minicart.getSectionsToRender().map(section => section.section), sections_url: location.pathname } : {}) };
        // Revalidate after the awaited snapshot. A BLOCKED fitment can arrive
        // while that GET is pending, and must prohibit any new cart write.
        if (this.dataset?.bmFitmentBlocked === 'true'
            || JSON.stringify(this.context) !== JSON.stringify(context)) {
          this.message('De passing of je keuze is gewijzigd. Controleer de gekozen velg voordat je toevoegt.');
          return;
        }
        posted = true;
        const response = await fetch(existing ? (window.routes?.cart_change_url || '/cart/change.js') : (window.routes?.cart_add_url || '/cart/add.js'), {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        });
        this.setAttribute('data-bm-cart-add-status', String(response.status));
        const added = await response.json();
        if (!response.ok || added.status || added.errors) {
          shopifyError = [added.description, added.errors].find(value => typeof value === 'string') || '';
          // Shopify may say 'sold out' after a USED NL shipping estimate even
          // when the exact wheel remains purchasable under BE delivery context.
          // Never present that ambiguous market/stock rejection as proven stock=0.
          if (response.status === 422 && /uitverkocht|sold out/i.test(shopifyError)) {
            shopifyError = 'Toevoegen is niet gelukt. Nieuwe velgen worden alleen in België geleverd. Controleer het verzendland in je winkelwagen en bereken het tarief opnieuw voor België. Lukt het niet, neem contact op.';
          }
          throw new Error('cart_add_failed');
        }
        accepted = true;
        // Ajax acceptance is not proof of the final physical quantity (another
        // tab can merge an intent). Confirm the exact native line before success.
        const receipt = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin', cache: 'no-store' });
        const current = await receipt.json();
        const confirmed = Array.isArray(current.items) ? current.items.filter(matchesIntent) : [];
        if (!receipt.ok || confirmed.length !== 1 || confirmed[0].quantity !== context.quantity || confirmed[0].properties?._bm_ref) throw new Error('cart_receipt_unconfirmed');
        committed = true;
        document.dispatchEvent(new CustomEvent(existing ? 'cart:item-quantity-update' : 'cart:item-add', { detail: { items: added.items, context: 'bm-new' } }));
        this.message(`Toegevoegd: ${context.quantity} ${context.quantity === 1 ? 'velg' : 'velgen'}.`);
        if (minicart) { minicart.renderContents(added); minicart.open(this.button); }
        else location.assign(window.routes?.cart_url || '/cart');
      } catch (_) {
        this.message(committed ? `Toegevoegd: ${context.quantity} ${context.quantity === 1 ? 'velg' : 'velgen'}. Controleer je winkelwagen.`
          : accepted ? 'De toevoeging kon niet worden bevestigd. Controleer je winkelwagen voordat je opnieuw toevoegt.'
          : shopifyError || (posted
            ? 'De toevoeging kon niet worden bevestigd. Controleer je winkelwagen voordat je opnieuw toevoegt.'
            : 'Toevoegen is niet gelukt. Probeer opnieuw.'));
      } finally {
        this.busy = false;
        this.setContext(this.context);
      }
    }
  });
}



